var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActividadesbsicas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 821.68 1022.94",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.08,108.8c-26.83-26.83-62.51-41.61-100.47-41.61h-59.94c-1.75-17.19-9.34-33.14-21.79-45.48-14.12-14-32.82-21.71-52.66-21.71h-268.77c-19.84,0-38.54,7.71-52.66,21.71-12.45,12.34-20.05,28.29-21.79,45.48h-59.93c-37.96,0-73.64,14.78-100.46,41.61C14.78,135.64,0,171.32,0,209.26v671.66c.09,37.9,14.91,73.52,41.71,100.32,26.8,26.8,62.42,41.61,100.32,41.7h537.58c37.92-.09,73.56-14.9,100.36-41.69,26.8-26.8,41.61-62.42,41.71-100.29V209.26c0-37.94-14.77-73.61-41.6-100.46ZM537.57,82.47v51.91h-253.48v-51.91h253.48ZM82.46,209.26c0-32.86,26.74-59.6,59.6-59.6h59.87c1.57,17.23,8.98,33.27,21.26,45.74,14.18,14.34,33.05,22.3,53.14,22.41h268.96c19.95-.1,38.67-7.92,52.75-22.02,12.51-12.51,20.08-28.7,21.68-46.13h59.87c32.86,0,59.59,26.74,59.59,59.6v670.7c0,32.84-26.72,59.55-59.58,59.55H142.06c-32.86,0-59.6-26.71-59.6-59.55V209.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActividadesbsicas);
export default __webpack_public_path__ + "static/media/Actividades básicas.b8d0de325f8e8d43626feecc7aaacd67.svg";
export { ForwardRef as ReactComponent };